import React, {PureComponent} from 'react'
import Ampersand from './icons'
import styles from './styles.css'

export default class Progress extends PureComponent {
  state = {
    amp: 0,
    progress: 0
  }

  componentDidMount() {
    this.strokeLength = this.alter.getTotalLength()
    this.ampInterval = setInterval(this.updateAmp, 350)
    this.progressInterval = setInterval(this.updateProgress, 100)
  }

  componentWillUnmount() {
    clearInterval(this.ampInterval)
    clearInterval(this.progressInterval)
  }

  updateAmp = () => {
    const {amp} = this.state

    this.setState({
      amp: amp === Ampersand.length - 1 ? 0 : amp + 1
    })
  }

  updateProgress = () => {
    const {progress} = this.state

    this.setState({
      progress: progress + 0.01
    })
  }

  calculateProgressStyle() {
    const {strokeLength} = this
    const {progress} = this.state

    if (!strokeLength) {
      return null
    }

    const strokeDashoffset = Math.floor(strokeLength * (1 - progress))
    const strokeDasharray1 = Math.ceil(strokeLength * progress * 1000) / 1000
    const strokeDasharray2 =
      Math.floor(strokeLength * (1 - progress) * 1000) / 1000

    return {
      strokeDashoffset,
      strokeDasharray: `${strokeDasharray1}, ${strokeDasharray2}`
    }
  }

  render() {
    const {amp} = this.state
    const style = this.calculateProgressStyle()

    /* eslint-disable max-len */
    return (
      <div className={styles.normal} hidden>
        <div className={styles.loader}>
          <div className={styles.wrapper}>
            <svg
              version="1.1"
              x="0px"
              y="0px"
              width="115.75px"
              height="115px"
              viewBox="0 0 115.75 115"
              enableBackground="new 0 0 115.75 115"
              xmlSpace="preserve">
              <g opacity="0.2">
                <path
                  fill="#000000"
                  d="M106.328,58.616c0,26.605-21.645,48.25-48.25,48.25s-48.25-21.645-48.25-48.25s21.645-48.25,48.25-48.25 S106.328,32.011,106.328,58.616z M104.135,58.616c0-25.396-20.661-46.057-46.057-46.057c-25.396,0-46.057,20.661-46.057,46.057 c0,25.396,20.661,46.057,46.057,46.057C83.474,104.673,104.135,84.012,104.135,58.616z"
                />
              </g>
              <path
                ref={(el) => {
                  this.alter = el
                }}
                className={styles.alter}
                style={style}
                fill="#ffffff"
                stroke="#000000"
                strokeWidth="2"
                strokeDashoffset="289.354"
                strokeDasharray="0, 289.354"
                d="M12.021,58.607c0-25.396,20.661-46.057,46.057-46.057c25.396,0,46.057,20.661,46.057,46.057 c0,25.396-20.661,46.057-46.057,46.057C32.683,104.664,12.021,84.003,12.021,58.607z"
              />
            </svg>
            <div className={styles.inner}>{Ampersand[amp]}</div>
          </div>
        </div>
      </div>
    )
    /* eslint-enable max-len */
  }
}
